export default {
  Home: {
    header: {
      hello_user: 'Hello {0}, welcome to',
      edit_farm: 'Farm editing',
      enable_farm: 'Disable farm',
      sown_area: 'Sown area',
      enable_farm_successfully: 'Farm enabled successfully.',
      she_disabled: 'Disabled',
    },
    header_no_farms: {
      welcome_no_farms: "You don't have farms registered at this time",
      manual_create_farm: 'Create farm manually',
      create_farm: 'Create farm',
    },
    quick_actions: {
      quick_actions: 'quick actions',
      see_catalog: 'see catalog',
      plan_fungicide: 'plan fungicide',
      create_note: 'create note',
      see_fields: 'see fields',
      register_sowing: 'register sowing',
    },
    item_list: {
      fields: 'fields',
      see_all: 'see all',
      active_sowings: 'active sowings',
      sowings: 'sowings',
    },
    sowing: {
      next_spray: 'Next spray',
      complete: 'complete',
      not_current_season:
        "The sowing is not from this season. It's not possible to edit it",
    },
    current_season_displayer: {
      season: 'Season',
    },
  },
}
